<template>
  <div class="div_get_code flex" :class="worring ? 'input_worring' : ''">
    <el-input
      v-model="codeTitle"
      @focus="worring = false"
      size="large"
      class="key_input"
      maxlength="6"
      placeholder="请输入6位短信验证码"
      @input="inputCode"
    />
    <p class="p_code">
      <span
        class="hover_color_t"
        v-if="!code.open"
        @click="clickGetCode"
        :class="{
          disabledColor: props.disabled,
        }"
        >{{ code.isFirst ? "获取验证码" : "重新获取" }}</span
      >
      <span v-else>{{ code.time + "s" }}</span>
    </p>
  </div>
</template>

<script setup>
import {
  ref,
  defineExpose,
  defineEmits,
  defineProps,
  onBeforeUnmount,
  onMounted,
} from "vue";

const props = defineProps(["modelValue", "getCode", "disabled"]);
const emit = defineEmits(["update:modelValue"]);

let codeTitle = ref("");
let worring = ref(false);

onMounted(() => {
  codeTitle.value = props.modelValue;
});

// 倒计时
let code = ref({
  open: false,
  time: 60,
  interval: null,
  isFirst: true, //是否首次获取验证码
});

function inputCode(value) {
  codeTitle.value = value;
  emit("update:modelValue", codeTitle.value);
}
// 获取验证码
function clickGetCode() {
  props.getCode((cando) => {
    if (cando) {
      code.value.open = true;
      setDownLoad();
    }
  });
}
// 设置倒计时
function setDownLoad() {
  code.value.interval = setInterval(() => {
    code.value.time--;
    if (code.value.time == 0) {
      code.value.open = false;
      code.value.time = 60;
      code.value.isFirst = false;
      clearInterval(code.value.interval);
      code.value.interval = null;
    }
  }, 1000);
}
onBeforeUnmount(() => {
  if (code.value.time) {
    clearInterval(code.value.time);
    code.value.time = null;
  }
});

defineExpose({
  worring,
});
</script>

<style lang='scss' scoped>
.div_get_code {
  border: 1px solid transparent;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  border-radius: 16px;
  height: 60px;
  transition: all $anim-time-fn-ease-out 0.25s;
  .key_input {
    :deep(.el-input__wrapper) {
      padding: 0 24px;
    }
  }
  .p_code {
    height: 60px;
    line-height: 60px;
    position: absolute;
    top: -1px;
    right: 24px;
    font-size: 16px;
    font-weight: 500;
    color: #35ba9f;
    user-select: none;
    .hover_color_t {
      color: #35ba9f !important;
    }
    .disabledColor {
      color: #aaaaaa !important;
    }
  }
}
.input_worring {
  border: 1px solid #f56c6c;
}
@media screen and (max-width: 768px) {
  .div_get_code {
    height: 0.6rem;
    border-radius: 0.1rem;
    .key_input {
      height: 0.6rem;
      :deep(.el-input__wrapper) {
        padding: 0 0.2rem;
        input {
          height: 0.6rem;
          font-size: 0.16rem;
        }
      }
    }
    .p_code {
      height: 0.6rem;
      line-height: 0.6rem;
      right: 0.2rem;
      font-size: 0.16rem;
    }
  }
}
</style>
